import firebase from "firebase";
export default class Auth {
  static instance;
  static _resolveInitPromise;
  static initPromise = new Promise(resolve => {
    Auth._resolveInitPromise = resolve;
  });
  constructor() {
    if (Auth.instance !== undefined) {
      return Auth.instance;
    } else {
      Auth.instance = this;
    }
  }

  get initPromise() {
    return Auth.initPromise;
  }
  signInAnonymously() {
    return firebase.auth().signInAnonymously();
  }

  signUpAnonymousUser(user, email, password) {
    let credential = firebase.auth.EmailAuthProvider.credential(
      email,
      password
    );
    return user.linkWithCredential(credential).catch(error => {
      let errorObject = {};
      switch (error.code) {
        case "auth/email-already-in-use":
          errorObject = {
            msg: "Email is already in use.",
            target: "email"
          };
          break;
        case "auth/invalid-email":
          errorObject = {
            msg: "Email is invalid.",
            target: "email"
          };
          break;
        case "auth/weak-password":
          errorObject = {
            msg: "Password is too weak.",
            target: "password"
          };
          break;
        default:
          errorObject = {
            msg: "Unknown error: " + error,
            target: undefined
          };
      }
      throw errorObject;
    });
  }
  signIn({ email, password }) {
    return firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .catch(error => {
        let errorObject = {};
        switch (error.code) {
          case "auth/user-not-found":
            errorObject = {
              msg: "Incorrect email or password.",
              target: "all"
            };
            break;
          case "auth/wrong-password":
            errorObject = {
              msg: "Incorrect email or password.",
              target: "all"
            };
            break;
          case "auth/too-many-requests":
            errorObject = {
              msg:
                "Too many unsuccessful login attempts. Please try again later.",
              target: "all"
            };
            break;
          default:
            errorObject = {
              msg: "Unkown error: " + error,
              target: "all"
            };
        }
        throw errorObject;
      });
  }

  signOut() {
    firebase.auth().signOut();
  }

  signUp({ email, password }) {
    return firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .catch(error => {
        let errorObject = {};
        switch (error.code) {
          case "auth/email-already-in-use":
            errorObject = {
              msg: "Email is already in use.",
              target: "email"
            };
            break;
          case "auth/invalid-email":
            errorObject = {
              msg: "Email is invalid.",
              target: "email"
            };
            break;
          case "auth/weak-password":
            errorObject = {
              msg: "Password is too weak.",
              target: "password"
            };
            break;
          default:
            errorObject = {
              msg: "Unknown error: " + error,
              target: undefined
            };
        }
        throw errorObject;
      });
  }
  verifyEmail(user) {
    return user.sendEmailVerification();
  }
  initAuth(callback) {
    firebase.auth().onAuthStateChanged(user => {
      callback(user);
      Auth._resolveInitPromise(user);
    });
  }
}
